import styled from 'styled-components';
import { Color } from '../../../common/view/color/color';
import { FontWeight } from '../../../common/view/font';
import { CssFuncs } from '../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'effect_menu_item',
  displayName: 'EffectMenuItem',
})`
  ${CssFuncs.css.padding({ xy: '10px' })}
  border-radius: 4px;

  &:hover {
    background-color: ${Color.alpha.white1};
  }

  transition: background 0.2s linear;
  user-select: none;
  cursor: pointer;
`;

const IconContainer = styled.div.withConfig({
  componentId: 'effect_menu_item_icon',
  displayName: 'EffectMenuItem.Icon',
})`
  width: max-content;

  padding: 8px;
  border-radius: 10px;
`;

const Title = styled.div.withConfig({
  componentId: 'effect_menu_item_title',
  displayName: 'EffectMenuItem.Title',
})`
  font-size: 18px;
  line-height: 1;
  font-weight: ${FontWeight.l1};

  color: ${Color.white1};
`;

const Subtitle = styled.div.withConfig({
  componentId: 'effect_menu_item_subtitle',
  displayName: 'EffectMenuItem.Subtitle',
})`
  font-size: 14px;
  line-height: 1;
  font-weight: ${FontWeight.base};

  color: ${Color.white7};
`;

export const EffectMenuItemStyle = {
  Container,
  IconContainer,
  Title,
  Subtitle,
};
